import LfDataService from '../../../Services/LfDataService';
import LfWebService from '../../../Services/LfWebService';

import {
    pageIsLoadingAction, 
    pageLoadedAction, 
    pageHasErroredAction, 
    pageErrorAction
} from '../../../State/actions';

export function loadStudentInsuranceTeaserDataAction() {
    const lfDataService = new LfDataService();

    return (dispatch) => {
        dispatch(pageIsLoadingAction(true));

        let serviceCall;

        lfDataService.paymentMethod().then(result => {
            dispatch(studentInsurancePaymentMethodLoadedAction(result.paymentMethod));
            dispatch(pageIsLoadingAction(false));
        }).catch(error => {
            dispatch(pageIsLoadingAction(false));
        });
    }
}

export function loadStudentInsurancePaymentMethodAction() {
    return (dispatch) => {
        dispatch(pageIsLoadingAction(false));
    };
}

export function studentInsuranceTeaserFormSubmitFailureAction(hasFailed) {
    return {
        type: 'STUDENT_SPECIAL_TEASER_FORM_SUBMIT_FAILURE',
        data: !!hasFailed
    };
}
export function studentInsuranceTeaserFormSubmittedAction(submitted, automatic) {
    return {
        type: 'STUDENT_SPECIAL_TEASER_FORM_SUBMITTED',
        data: {
            submitted: !!submitted,
            automatic: !!automatic
        }
    };
}

export function studentInsurancePaymentMethodLoadedAction(data) {
    return {
        type: 'STUDENT_SPECIAL_PAYMENT_METHOD_LOADED',
        data
    };
}

export function submitStudentInsuranceForm(data, automatic) {
    const lfDataService = new LfDataService();

    return (dispatch) => {
        dispatch(pageIsLoadingAction(true));

        let serviceCall;

        if (automatic) {
            const { insurancename, accountnumber, bankcode, IsFullyAbleToWork, PurchaseTermsApproved } = data;
            serviceCall = lfDataService.extendStudentInsuranceAutomatic(insurancename, accountnumber, bankcode, IsFullyAbleToWork, PurchaseTermsApproved);
        } else {
            const { insurancename, IsFullyAbleToWork, PurchaseTermsApproved } = data;
            serviceCall = lfDataService.extendStudentInsurance(insurancename, IsFullyAbleToWork, PurchaseTermsApproved)
        }


        serviceCall
            .then(result => {
                dispatch(pageIsLoadingAction(false));

                if (result.success) {
                    dispatch(studentInsuranceTeaserFormSubmitFailureAction(false));
                    dispatch(studentInsuranceTeaserFormSubmittedAction(true, automatic));
                    return;
                }

                dispatch(studentInsuranceTeaserFormSubmittedAction(false, automatic));
                dispatch(studentInsuranceTeaserFormSubmitFailureAction(true));
            })
            .catch(e => {
                dispatch(pageIsLoadingAction(false));
                dispatch(studentInsuranceTeaserFormSubmitFailureAction(true));
            });
    }
}